import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import {notification, getPdfDataOrder, getPdfDataWheelChanger, getPdfDataOutgoing} from './helpers'

pdfMake.vfs = pdfFonts.pdfMake.vfs

export default function printDocument(data) {


    let docDefinition = null;

    if (typeof(data) !== "undefined" && typeof(data.pdfType) !== "undefined") {

        switch (data.pdfType) {
            case "order":
                docDefinition = getPdfDataOrder(data);
                break;
            case "wheelChanger":
                docDefinition = getPdfDataWheelChanger(data);
                break;
            case "outgoing":
                docDefinition = getPdfDataOutgoing(data);
                break;
            default:
                notification("Could not generate pdf, undefined type of pdf" + data.pdfType);
                return;
        }

        docDefinition.defaultFileName = data.pdfType + "-" + data.id + ".pdf";
        docDefinition.info = {
            title: data.pdfType + "-" + data.id,
            author: 'WheelIt',
            subject: data.pdfType + "-" + data.id,
            keywords: data.pdfType
        };

        if (window.navigator.msSaveOrOpenBlob) {
            pdfMake.createPdf(docDefinition).getBlob(result => {
                window.navigator.msSaveOrOpenBlob(result)
            })
        } else {
            pdfMake.createPdf(docDefinition).open();
            //pdfMake.createPdf(docDefinition).download(docDefinition.defaultFileName);
        }

    } else {
        notification("Could not generate pdf, not set type of pdf");
        return;
    }
}


// WEBPACK FOOTER //
// ./src/printDocument.js